import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IGetDealerMarkups } from '../models/models'

export class GetDealerMarkupsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/get-dealer-markups',
      requesterInfo,
    })
  }

  public async getDealerMarkups(): Promise<IGetDealerMarkups> {
    return await this.getAsync<IGetDealerMarkups>()
  }
}
